export default "__VITE_ASSET__BjoCjq04__"